import {Component, HostBinding, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-menu-list-component',
  templateUrl: './menu-list-component.component.html',
  styleUrls: ['./menu-list-component.component.css'],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({transform: 'rotate(0deg)'})),
      state('expanded', style({transform: 'rotate(180deg)'})),
      transition('expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
      ),
    ])
  ]
})
export class MenuListComponentComponent implements OnInit {
  expanded: boolean =  false;
  @Input() item: any;
  @Input() depth: number;
  @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;

  constructor(public router: Router) {
    if (this.depth === undefined) {
    this.depth = 0;
    }
}

  ngOnInit(): void {
  }

  onItemSelected(item) {
    if (!item.children || !item.children.length) {
      this.router.navigate([item.path]);
    }
    if (item.children && item.children.length) {
      this.expanded = !this.expanded;
    }
  }

}
